import type { AxiosInstance } from 'axios';
import type { ErrorResult, OkResult, StringifiedParams } from './types';

export const curry1 = <R = any, T extends any[] = any[]>(
  fn: (instance: AxiosInstance, ...rest: T) => Promise<R>
) => {
  return (instance: AxiosInstance) => {
    return (...rest: T) => {
      return fn(instance, ...rest);
    };
  };
};

export const curry2 = <P, R = any, T extends any[] = any[]>(
  fn: (instance: AxiosInstance, x: P, ...rest: T) => Promise<R>
) => {
  return (instance: AxiosInstance, x: P) => {
    return (...rest: T) => {
      return fn(instance, x, ...rest);
    };
  };
};

export const curry3 = <P1, P2, R = any, T extends any[] = any[]>(
  fn: (instance: AxiosInstance, x: P1, y: P2, ...rest: T) => Promise<R>
) => {
  return (instance: AxiosInstance, x: P1, y: P2) => {
    return (...rest: T) => {
      return fn(instance, x, y, ...rest);
    };
  };
};

export const err = <T>(error: T, status: number): ErrorResult<T> => {
  return { ok: false, error, status };
};

export const ok = <T>(data: T): OkResult<T> => {
  return { ok: true, data };
};

export const stringifyParams = <T extends object>(
  params?: T
): StringifiedParams<T> | undefined => {
  if (!params) {
    return params;
  }

  const result: any = {};

  for (const [key, value] of Object.entries(params)) {
    result[key] = Array.isArray(value) ? value.join(',') : value;
  }

  return result;
};
